import React, { useState, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import styles from './RecordingVideo.module.css'
import Header from '../../component/Header/header';
import ProgressBarDokSul from '../../component/ProgressBarDokSul/progressbardoksul';
import { Col, Row, Modal } from 'react-bootstrap';
import Spinners from '../../component/Spinner/spinners';
import { getStatement, getProductScript, rejectVidPernyataan, convertVideo, checkValid, saveAnswer,updatePreambules, getVideoPending } from '../../store/features/CameraAndSignatureSlice';
import { StatusCustomer } from '../../component/Helper'
import VideoRecorder from 'react-video-recorder'
import 'font-awesome/css/font-awesome.min.css';
import {Recorder} from './Recorder'
import confApi from '../../Config/Api'
import Perekam from './Perekam';


const RecordingVideo = () => {
  const {state} = useLocation();
  const data = new FormData();
  const { SPAJs } = useSelector((state) => state.SPAJs)

  let dispatch = useDispatch()
  let navigate = useNavigate()
  let [prevVid, setPrevVid] = useState(null)
  let [loading, setLoading] = useState(false)
  let [getVideoss, setGetVideoss] = useState(null)
  let [playVideo, setPlayVideo] = useState(false)
  let [confirmButton, setConfirmButton] = useState(false)
  let [confirmVid, setConfirmVid] = useState(false)
  let [next, setNext] = useState(false)
  let [showCamera, setShowCamera] = useState(false)
  let [showHide, setShowHide] = useState(false)
  let [showHideError, setShowHideError] = useState(false)
  let [videoSaved, setVideoSaved] = useState(false)
  const [showInfo, setShowInfo] = useState(false)
  const [statement, setStatement] = useState(null)
  const [productScript, setProductScript] = useState(null)
  const [currentStatement, setCurrentStatement] = useState(null)
  const { DeviceId } = useSelector((state) => state.DeviceId)
  const { Video } = useSelector((state) => state.Video)
  const { Parameter } = useSelector(state => state.Params)
  const { SPAJDetail } = useSelector((state) => state.SPAJsDetail)
  const [statusCustomer, setStatusCustomer] = useState("");
  const [checkPending, setCheckpending] = useState(false);
  const [bisaLanjut, setBisaLanjut] = useState(false)

  const [audio, setAudio] = useState(null);
  const [dbAnswer, setDbAnswer] = useState(null);

  const [jawaban, setJawaban] = useState("...");
  const [jawabanTemp, setJawabanTemp] = useState("...");
  const [checkAnswer, setCheckAnswer] = useState("...");

  const [showPopupPreambule, setShowPopupPreambule] = useState(false)
  const [showWarning, setShowWarning] = useState(false)
  const [currentWarning, setCurrentWarning] = useState(0)
  const [mulai, setMulai] = useState(false)
  const [pertanyaan, setPertanyaan] = useState(null)
  const [statusPertanyaan, setStatusPertanyaan] = useState(null)
  const [pertanyaanFlag, setPertanyaanFlag] = useState([])
  const [seconds, setSeconds] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const [sudahPlay, setSudahPlay] = useState(false)
  const [recorder, setRecorder] = useState(null);
  const [videoForMerge, setVideoForMerge] = useState(null);
  const [readySend, setReadySend] = useState(false);
  const [sesiDimulai, setSesiDimulai] = useState(null);
  const [statementVoice, setStatementVoice] = useState(null);
  const word = 'Tekan tombol bulat merah <span style="display: inline-block; width: 20px; height: 20px; background-color: red; border-radius: 50%; vertical-align: middle; margin-left: 5px; margin-right: 5px;"></span> untuk menjawab <span style="color: #C70039;">"Ya"</span> !';
  const word2 = 'Tekan tombol kotak merah <span style="display: inline-block; width: 20px; height: 20px; background-color: red; vertical-align: middle; margin-left: 5px; margin-right: 5px;"></span> setelah menjawab pertanyaan';
  const [wordingBot, setWordingBot] = useState(null);
  let [wordingModal, setWordingModal] = useState("Terjadi Kesalahan");
  let [showPopupLengkapi, setShowPopupLengkapi] = useState(false);
  const [recording, setRecording] = useState(false);
  const [transcribe, setTranscribe] = useState(false);
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const [recordedChunks, setRecordedChunks] = useState([]);
  const [audioBlob, setAudioBlob] = useState(null)
  const [audioFlag, setAudioFlag] = useState([])
  const [randomName, setRandomName] = useState(null)
  const [mediaSupport, setMediaSupport] = useState('mp4')
  
  const [preambule, setPreambule] = useState(false)
  const platform = window.navigator.platform;
  const videoRecorderRef = useRef();
  const videoVoice = useRef();
  const [secondsLocal, setSecondsLocal] = useState(0)


  const handleStartRecording = () => {
    getVideo();
    setPertanyaanFlag([])
    setAudioFlag([])
    setSesiDimulai(null)
    setSeconds(0)
    setIsRunning(false)
    if (intervalRef.current) clearInterval(intervalRef.current);
    setSudahPlay(false)
    setPlayVideo(false)
    setConfirmButton(false)
    setPrevVid(null);
    setGetVideoss(null);

    // setRecording(true)
    setStatusPertanyaan(null)
    startTimer()
    setShowInfo(false)
    setStatusPertanyaan(null)
    setMulai(true)
    setShowWarning(false)
    setCurrentWarning(0)
    setBisaLanjut(false)
    // setCurrentStatement(1)
    // setPertanyaan(statement.dataStatement.Q1)
    setJawaban("...")
    setAudio(null)
    // speak(statement.dataStatement.Q1, 1);
    requestMicAccess()
    setTimeout(() => {
      setStatusPertanyaan('ended')
      setSecondsLocal(10)
    }, 1500);
    setWordingBot(word)
    getAnswerApprove()


  };


  function getAnswerApprove() {
    Parameter.dataParameterApps.find(url =>{
      if (url.codeSetting == "ANSWER_APPROVE"){
          let arrayAnswer = url.valueSetting.split(",")
          setDbAnswer(arrayAnswer);
      }
    })
  };


  const intervalRef = useRef();

  useEffect(() => {
    console.log(state);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);
  
  const startTimer = () => {
    if (isRunning) return;

    setIsRunning(true);
    intervalRef.current = setInterval(() => {
      setSeconds((prevTime) => prevTime + 1);
    }, 1000);
  };


  useEffect(() => {
    console.log(mulai, jawaban)
    // const kataKata = ["iya", "ya", "yes", "yah", "Oke", "Ok", "Iya saya mengerti", "Iya mengerti", "Ok saya mengerti", "Ok mengerti", "Saya mengerti", "Mengerti"];
    
    if (dbAnswer && dbAnswer.indexOf(jawaban.toLowerCase()) >= 0) {
      // if (kataKata.some(k => jawaban.toLowerCase().includes(k))) {
      var nextStatement = parseInt(currentStatement) + 1;
      var nextQuestion = statement.dataStatement["Q" + nextStatement]
      setStatusPertanyaan(null)
      setCurrentWarning(0)
      setCurrentStatement(nextStatement)
      if (nextQuestion) {
        setPertanyaan(nextQuestion)
        setJawaban('...');
      } else {
        setBisaLanjut(true);
        setRecording(false);
      }
    } else {
      if (mulai && jawaban != "...") {
        var warn = 2;
        setCurrentWarning(warn)
        setJawabanTemp(jawaban)
        let warning = statement.dataWarning.w2
        if (warning) {
          setJawaban('...')
          var newWarn = warn + 1;
          setShowWarning(warning)
          if (!statement.dataWarning["W" + newWarn]) {
            tutupPertanyaan()
            // sendReject()
          }
        }
      }
    }
  }, [jawaban]);

  const handleWarning = () => {
    setShowWarning(false);
    if (currentWarning <= 1) {
      // speak();
      setStatusPertanyaan('ended')
      setJawabanTemp('...')
    }
  }

  const sendReject = () => {
    let dataVids = {
      deviceId: `${DeviceId.deviceId}`,
      userName: `${SPAJDetail.dataSpaj.email}`,
      spajNumber: `${SPAJDetail.dataSpaj.spajNumber}`,
    }

    dispatch(rejectVidPernyataan(dataVids))
      .then(response => {
        console.log("responnse get statement ", response)
        if (response.payload.status == "OK") {
          // setPopup()
        }
        setLoading(false)
      }).catch(err => {
        setLoading(false)
      })
  }

  useEffect(() => {
    setLoading(true)
    setStatusCustomer(StatusCustomer(SPAJs.spajHeader.statusCustomer));
    if (SPAJs.spajHeader.statusCustomer == "PDC") {
      setCheckpending(true);
    }
    let dataVids = {
      deviceId: `${DeviceId.deviceId}`,
      userName: `${SPAJDetail.dataSpaj.email}`,
      spajNumber: `${SPAJDetail.dataSpaj.spajNumber}`,
    }
    dispatch(getVideoPending(dataVids))
      .then(response => {
        console.log("responnse get video ", response)
        if (response.payload.data.isSimpan == "1") {
          setVideoSaved('1')
        }
        if (response.payload.data.isPreambule == "1") {
          setPreambule('1');
        }
        setLoading(false)
      }).catch(err => {
        setLoading(false)
      })

    dispatch(getStatement(dataVids))
      .then(response => {
        console.log("responnse get statement ", response)
        if (response.payload.status == "OK") {
          setStatement(response.payload.data)
        }
        setLoading(false)
      }).catch(err => {
        setLoading(false)
      })

    dispatch(getProductScript(dataVids))
      .then(response => {
        console.log("responnse get ps ", response)
        if (response.payload.status == "OK") {
          setProductScript(response.payload.data.dataWording)
        }
        setLoading(false)
      }).catch(err => {
        setLoading(false)
      })
  }, [])

  let daata = Parameter.dataParameterApps?.find(url => {
    if (url.codeSetting == "VIDEO_DURATION") {
      return url.valueSetting
    }
  })

  const getVideo = async () => {
    setShowCamera(true)
  }

  const bukaPertanyaan = () => {
    setPertanyaanFlag([])
    setAudioFlag([])
    setSesiDimulai(null)
    setStatusPertanyaan('playing')
    setSeconds(0)
    setIsRunning(false)
    if (intervalRef.current) clearInterval(intervalRef.current);

    setSudahPlay(false)
    setCurrentStatement(null)
    setPlayVideo(false)
    setConfirmButton(false)
    setPrevVid(null);
    setGetVideoss(null);
    speak2(productScript)
    setShowInfo(true)
    setWordingBot(word)
  }

  const tutupPertanyaan = () => {
    setRecording('close')
    setStatusPertanyaan(null)
    setSeconds(0)
    setIsRunning(false)
    if (intervalRef.current) clearInterval(intervalRef.current);

    setSudahPlay(false)
    setCurrentStatement(null)
    setPlayVideo(false)
    setConfirmButton(false)
    setPrevVid(null);
    setGetVideoss(null);
    if (audio)
      audio.pause()
    setShowInfo(false)
    setShowCamera(false)
  }

  const setPopup = () => {
    setNext(true)
    setConfirmVid(true)
    setShowHide(false)
    setConfirmButton(false)
  }

  const setPopupError = () => {
    setShowHideError(false)
  }
  

  const fetchSpeechAudio = async (text) => {
    const apiUrl = confApi.host+'/'+confApi.routeVidConvert+'/vidconvert/textToSpeech';

    const requestBody = {
      input: { text },
      voice: { languageCode: 'id-ID', ssmlGender: 'NEUTRAL' },
      audioConfig: { audioEncoding: 'MP3',speakingRate: '1.15' },
    };

    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });

    const data = await response.json();
    const audioContent = Uint8Array.from(atob(data.audioContent), (c) => c.charCodeAt(0));
    const audioUrl = URL.createObjectURL(new Blob([audioContent], { type: 'audio/mp3' }));
    setStatementVoice(audioUrl)
    return audioUrl;
  };

  const muteAudio = async () => {
    if (mediaRecorder && mediaRecorder.stream) {
      mediaRecorder.stream.getTracks().forEach(async (track) => {
        track.stop()
        setMediaRecorder(null)
      });
    }
  }

  const speak = async (newquest = null, statementNum) => {
    setStatusPertanyaan('playing')
    await muteAudio()
    const text = (newquest) ? newquest : pertanyaan;
    const audioUrl = await fetchSpeechAudio(text);

    var newFlag = {
      no: (statementNum) ? statementNum - 1 : (currentStatement - 1),
      at: seconds
    }
    console.log(newFlag, 'pertanyaanflag')
    setPertanyaanFlag([...pertanyaanFlag, newFlag]);

    if (audio) {
      audio.pause();
    }

    const newAudio = new Audio(audioUrl);
    setAudio(newAudio);
    console.log(mediaRecorder)
    newAudio.play();
    newAudio.addEventListener('ended', () => {
      requestMicAccess()
      setTimeout(() => {
        setStatusPertanyaan('ended')
      }, 1500);
    });
  };

  const speak2 = async (aggrement) => {
    console.log("aggrement",aggrement)

    const text = aggrement;
    const audioUrl = await fetchSpeechAudio(text);

    if (audio) {
      audio.pause();
    }

    const newAudio = new Audio(audioUrl);
    setAudio(newAudio);
    newAudio.addEventListener('ended', () => {
      setSudahPlay(true)
    });
    newAudio.play();

  };

  const updatePreambule = () =>{
    let insertData = {
      deviceId: `${DeviceId.deviceId}`,
      userName: `${SPAJDetail.dataSpaj.email}`,
      spajNumber: `${SPAJDetail.dataSpaj.spajNumber}`,
    };

    dispatch(updatePreambules(insertData)).then((res2) => {
      if (res2.payload.status == "OK") {
        handleStartRecording();
        setPreambule('1')
      }
    });



  };
  
  const handleConvertVideo = async (chunks) => {
    setLoading(true)
    const videoBlob = new Blob(chunks, { type: 'video/mp4' });
    // let url = URL.createObjectURL(videoBlob);
    // let a = document.createElement('a');
    // document.body.appendChild(a);
    // a.href = url;
    // a.download = 'test.webm';
    // a.click();
    // window.URL.revokeObjectURL(url);
    data.append("videoBlob", videoBlob)
    // data.append("timeline", JSON.stringify(pertanyaanFlag))
    data.append("dataAnswer", JSON.stringify(audioFlag))
    // data.append("voice", JSON.stringify([statement.dataStatement.Q1,
    // statement.dataStatement.Q2,
    // statement.dataStatement.Q3,
    // statement.dataStatement.Q4]))
    data.append("spajNumber", `${SPAJDetail.dataSpaj.spajNumber}`)
    data.append("agentCode", `${SPAJDetail.dataSpaj.agentCode}`)
    data.append("illustrationNumber", `${SPAJDetail.dataSpaj.illustrationNumber}`)
    data.append("leadNumber", `${SPAJDetail.dataSpaj.leadNumber}`)
    data.append("deviceId", `${DeviceId.deviceId}`)
    data.append("mime", videoBlob.type)
    data.append("userName", `${SPAJDetail.dataSpaj.email}`)
    console.log(videoBlob, videoBlob.type)
    dispatch(convertVideo(data))
      .then(response => {
        console.log(response)
        if (response.payload.data && response.payload.data.status == "OK") {
          // setPrevVid(response.payload.data.url);
          // setGetVideoss(videoBlob);
          setLoading(false)
          setShowHide(true)
          setVideoSaved('1')
          setMulai(false)
          setShowCamera(false)
        }else 
        // if (response.payload.data && response.payload.data.status == "ERROR")
         {
          setLoading(false)
          setShowHideError(true)
        } 
        // else {
        //   setLoading(false)
        //   setShowHide(true)
        //   setVideoSaved(1)
        //   setMulai(false)
        //   setShowCamera(false)
        // }
      })
  }

  const kirimMerge = () => {
    // if (currentStatement >= Object.keys(statement.dataStatement).length)
      handleConvertVideo(recordedChunks)
  }

  const ModalLengkapi = ({
    showPopupLengkapi,
    setShowPopupLengkapi,
    wordingModal,
  }) => {
    return (
      <>
        <Modal
          dialogClassName={styles.modalcustom}
          centered
          show={showPopupLengkapi}
        >
          <Modal.Body>
            <div className={styles.containerModal}>
              <p className="fs-15 text-center mb-25">{wordingModal}</p>
              <div onClick={() => setShowPopupLengkapi(false)}>
                <div>
                  <button className={styles.buttonnextmodal}>OK</button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  };

  const kirimspaj = () => {
    let insertData = {
      deviceId: `${DeviceId.deviceId}`,
      userName: `${SPAJDetail.dataSpaj.email}`,
      spajNumber: `${SPAJDetail.dataSpaj.spajNumber}`,
    };
    dispatch(checkValid(insertData)).then((res2) => {
      if (res2.payload.status == "OK") {
        setLoading(false);
        navigate( "/otp-konfirmasi");
      } else {
        setLoading(false);
        let msg = res2.payload.status_message || res2.payload.errMsg || res2.payload.error || 'Terjadi Kesalahan'
        setWordingModal(msg);
        setShowPopupLengkapi(true);
        setLoading(false);
      }
    });

  }

  const toggleRecording = () => {
    setRecording(!recording);
  };

  const handleCaptureError = (error) => {
    console.error('Video capture failed:', error);
    setWordingModal('Kamera atau mikrofon tidak dapat digunakan. Pastikan izin aktif dan browser mendukung perekaman.');
    setShowCamera(false);
    setShowPopupLengkapi(true);
    setRecording(false);
    setTranscribe(false);
  };

  const requestMicAccess = async () => {
    try {
      console.log('REQUEST BARU')
      var audioChunks = [];
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia || !window.MediaRecorder) {
        throw new Error('Perekaman audio tidak didukung oleh browser ini.');
      }
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      let mimeType = null;
      if (window.MediaRecorder.isTypeSupported && window.MediaRecorder.isTypeSupported("audio/mp4")) {
        mimeType = "audio/mp4";
      } else if (window.MediaRecorder.isTypeSupported && window.MediaRecorder.isTypeSupported("audio/webm")) {
        mimeType = "audio/webm";
      }

      const recorder = mimeType
        ? new window.MediaRecorder(stream, { mimeType })
        : new window.MediaRecorder(stream);
      const recordedMimeType = recorder.mimeType || mimeType || 'audio/mp4';
      setMediaSupport(recordedMimeType.includes('webm') ? 'webm' : 'mp4');

      setMediaRecorder(recorder);
      console.log("recorder",recorder)
      recorder.onstop = () => {
        const blob = new Blob(audioChunks, { type: recordedMimeType });
        audioChunks = [];
        setAudioBlob(blob)
      };

      recorder.addEventListener("dataavailable", (event) => {
        audioChunks.push(event.data);
      });

    } catch (error) {
      console.error("Error requesting microphone access:", error);
      handleCaptureError(error);
    }
  };

  function makeid(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }

  const startRecording = async () => {
    if (!mediaRecorder || typeof mediaRecorder.start !== 'function' || mediaRecorder.state !== 'inactive') {
      handleCaptureError(new Error('Perekam audio belum siap.'));
      return;
    }

    setRecording(true)
    setTranscribe(true)
    setWordingBot(word2)
    try {
      mediaRecorder.start();
    } catch (error) {
      handleCaptureError(error);
      return;
    }
    console.log("mediaSupport",mediaSupport)
    var name = makeid(6) + "." + mediaSupport;
    setRandomName(name)
    var newFlag = {
      name: name,
      at: 0
    }
    setAudioFlag([...audioFlag, newFlag]);
  };

  const stopRecording = () => {
    console.log('kesto')
    setWordingBot(word)
    setStatusPertanyaan('playing')
    setTranscribe(false)
    if (mediaRecorder && mediaRecorder.state !== 'inactive') {
      mediaRecorder.stop();
      muteAudio()
      setMediaRecorder(null)
    }
  };

  const sendAnswer = async (answer) => {
    const sending = new FormData();
    sending.append("dataAnswer", answer)
    sending.append("name", randomName)
    sending.append("spajNumber", `${SPAJDetail.dataSpaj.spajNumber}`)

    try {
      console.log(sending)
      dispatch(saveAnswer(sending))
    } catch (error) {
      console.error('There was an error!', error);
    }
  }

  useEffect(() => {
    if (audioBlob) {
      console.log(audioBlob, 'berhasil')
      sendAnswer(audioBlob)
    }
  }, [audioBlob])

  useEffect(() => {
    if (readySend) {

      if (currentStatement >= Object.keys(statement.dataStatement).length) {
        console.log(pertanyaanFlag)
        console.log(audioFlag)
        console.log(recordedChunks)
      }
    }
  }, [readySend])
  return (
    <>
      {showPopupLengkapi == true && (
        <ModalLengkapi
          showPopupLengkapi={showPopupLengkapi}
          setShowPopupLengkapi={setShowPopupLengkapi}
          wordingModal={wordingModal}
        />
      )}
      {loading == true && <Spinners />}
      <div>
        <Header />
        <div className="g-0 welcome-container">
          <div className={`position-relative ${styles.bgContainer}`}>
            {/* <ProgressBarDokSul step='1' status={9}/> */}
            <div className={styles.allCardGreyfinalstep}>
              <div className={styles.cardContainer}>
                <div className='pt-25'>
                  <Row>
                    <Col xs={12} sm={12} md={12} lg={6}>
                      <div>
                        <div>
                          <Perekam setRecordedChunks={setRecordedChunks} setReadySend={setReadySend} setJawaban={setJawaban} recording={recording} transcribe={transcribe} onRecordingToggle={toggleRecording} onError={handleCaptureError} />
                        </div>

                        <div className='border-finalstep'>
                          {playVideo == true ? (<>
                            <video src={prevVid} autoPlay width="100%" height="200" controls />
                          </>) : videoSaved == "1" ? (<>
                            <div>
                              <img src='/images/checked.png' className={styles.imageChecked} />
                            </div>
                          </>) : (<>
                            <img src="/images/iconcamera.png" className={`${styles.iconCamera}`} />
                          </>)}

                        </div>

                        <div className='mt-10'>
                          <div className={`${styles.containerButtonCam}`}>
                            <button disabled={confirmVid || prevVid || videoSaved == "1"} onClick={() => {  preambule =='1' ? setShowPopupPreambule(true) : bukaPertanyaan(); }} className={!confirmVid && videoSaved == "0" ? `${styles.buttonambilfoto}` : `${styles.buttonkonfirDisable}`}>
                              Ambil Video Rekaman
                            </button>
                            {/* <button disabled={!confirmButton || videoSaved == "1"} onClick={() => confirmVideo()} className={confirmButton && videoSaved == "0" ? `${styles.buttonkonfir}` : `${styles.buttonkonfirDisable}`}>
                              Konfirmasi
                            </button> */}
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={6}>
                      <div className='pt40'>
                        <div className='fs-14' >Sesuai dengan ketentuan Otoritas Jasa Keuangan, Calon Nasabah diwajibkan untuk membuat rekaman Video Pernyataan Pemahaman Pembelian Produk Asuransi.</div>
                        <div className='mt-20 fs-14'>Sebelum memulai video rekaman mohon dapat diperhatikan petunjuk berikut:</div>
                        <div className='mt-20 fs-14'>1.	Untuk memulai rekaman, Anda dapat menekan tombol “Ambil Video Rekaman” diatas.</div>
                        <div className='mt-20 fs-14'>2.	Setelah menekan tombol “Ambil Video Rekaman” maka kami akan memberikan penjelasan kembali mengenai produk Asuransi yang akan Anda beli, dilanjutkan dengan pertanyaan konfirmasi yang harus Anda jawab.</div>
                        <div className='mt-20 fs-14'>3.	Rekaman video akan dimulai sejak Anda menekan tombol “Ambil Video Rekaman”, oleh sebab itu pastikan Anda telah bersiap memposisikan wajah Anda dihadapan “kamera depan” gadget Anda ketika mendengarkan penjelasan dan memberikan jawaban atas pertanyaan yang diajukan.</div>
                        <div className='mt-20 fs-14'>4.	Pastikan gadget Anda tidak berada dalam mode sunyi/senyap (<i>silent mode</i>) agar Anda dapat mendengarkan penjelasan dan pertanyaan yang diajukan.</div>
                        <div className='mt-20 fs-14'>5. Untuk pengguna iPhone mohon dipastikan minimal adalah <b>IOS 16</b> dan untuk pengguna Android minimal 10</div>
                      </div>

                    </Col>
                  </Row>
                </div>
              </div>
              <div className={styles.pbotton}>
              <div style={{ display: 'flex' }}>
                  <div className={next || videoSaved == "1" ? styles.buttonnext : styles.buttonnextDisable}>
                    <button onClick={() => {
                      navigate( "/dokumen-susulan", {state: {idx: state.idx, val: true}});
                    }}>SIMPAN</button>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.linkFooter}>
              <div>www.generali.co.id</div>
            </div>
          </div>
        </div>
      </div>
      <Modal centered show={showCamera}>
        <div>
          <div className={styles.closeButton} onClick={() => { tutupPertanyaan() }}>
            x
          </div>
        </div>
        <div className={styles.twoColumns}>
          {/* <div className={styles.column}>
            <button disabled={statusPertanyaan == 'playing' || bisaLanjut} onClick={() => speak()} className={(statusPertanyaan == 'playing' || bisaLanjut) ? styles.roundButtonDisabled : styles.roundButton}>
              <i className="fa fa-play"></i>
            </button>
          </div>*/}
            {!bisaLanjut &&  <div className={styles.columnTwoCenter} dangerouslySetInnerHTML={{ __html: wordingBot }}>
          </div>  }
              
        </div>
        <div className={styles.boxPertanyaan}>
          <small>{(statusPertanyaan && statement && statement.dataStatement && (currentStatement >= 1 && currentStatement <= 4)) && statement.dataStatement["Q" + currentStatement]}</small>
        </div>
        <div>
          {/* {audioFlag && 
          <p>{JSON.stringify(audioFlag)}</p>
          }
          <h1>Timer: {seconds}</h1> */}
          {/* {jawaban} */}
          <div style={{ position: 'relative' }}>
            <VideoRecorder
              ref={videoVoice}
              key={currentStatement + "_" + currentWarning}
              isFlipped={false}
              isOnInitially
              replayVideoAutoplayAndLoopOff={true}
              timeLimit={10000}
              countdownTime={0}
              constraints={{
                audio: false,
                video: true
              }}
              onStartRecording={startRecording}
              onRecordingComplete={() => { }}
              onStopRecording={stopRecording}
              onError={handleCaptureError}
            />
            {statusPertanyaan != 'ended' && <div className={styles.disableLayer}></div>}
          </div>
          <div className={styles.pad20}>
            {/* {!bisaLanjut && 
            <div className={styles.centerText} dangerouslySetInnerHTML={{ __html: wordingBot }}></div>
            } */
            <p className='fs-15 text-center'>         
              <b>Jawaban Anda : 
               <span className='jawaban-merah'> 
                  {jawaban} 
                </span> 
              </b>
            </p>
            }

            <div className={styles.twoColumns}>
              <button onClick={() => { kirimMerge(); }} className={bisaLanjut ? `${styles.buttonambilfoto}` : `${styles.buttonkonfirDisable}`} disabled={!bisaLanjut}>
                Kirim Rekaman
              </button>
            </div>
          </div>
        </div>
      </Modal>
      <Modal dialogClassName={styles.modalcustom} centered show={showHide}>
        <Modal.Body>
          <div className='d-flex flex-column justify-content-center align-items-center'>
            {/* <p className='fs-15 text-center'>Berhasil Konfirmasi</p> */}
            <p className='fs-15 text-center'>Rekaman video berhasil</p>
            <div onClick={() => setPopup()}>
              <div className={styles.buttonkembalimodal}>
                <button>OK</button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal dialogClassName={styles.modalcustom} centered show={showHideError}>
        <Modal.Body>
          <div className='mt-40 d-flex flex-column justify-content-center align-items-center'>
            {/* <p className='fs-15 text-center'>Gagal Konfirmasi</p> */}
            <p className='fs-15 text-center'>Rekaman video tidak berhasil. Pastikan jaringan seluler Anda dalam kondisi baik dan wajah Anda terlihat jelas saat perekaman video.</p>
            <div onClick={() => setPopupError()}>
              <div className={styles.buttonkembalimodal}>
                <button>OK</button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal dialogClassName="modalcustom" centered show={showWarning}>
        <Modal.Body style={{ margin: 25 }}>
          <div className='d-flex flex-column justify-content-center align-items-center'>
            <p className='fs-15 text-center bold'>Jawaban Anda : {jawabanTemp}<br/></p>
            <p className='fs-15'>{showWarning}</p>
            <div onClick={() => { handleWarning() }}>
              <div className="buttonkembalimodal">
                <button>OK</button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal dialogClassName="modalcustom" centered show={showPopupPreambule}>
        <div>
          <div className={styles.closeButton} onClick={() => { setShowPopupPreambule(false) }}>
            x
          </div>
        </div>
        <Modal.Body style={{minHeight:150 }}>
          <div className='d-flex flex-column justify-content-center align-items-center'>
            <p className='fs-15'>Apakah Anda ingin mendengar penjelasan ulang ?</p>

            <table>
              <tr>
                <th style={{paddingRight:30}}>
                  <button className={styles.buttonPreambule} onClick={() =>{setShowPopupPreambule(false); bukaPertanyaan();} }>
                    <p className='fs-15'>Dengarkan Kembali</p>
                  </button>
                </th>
                <th>
                  <button className={styles.buttonPreambule} onClick={() => {setShowPopupPreambule(false); handleStartRecording();} }>
                    <p className='fs-15'>Langsung menjawab pertanyaan </p>
                  </button>
                </th>
              </tr>
            </table>
            
          </div>
        </Modal.Body>
      </Modal>
      <Modal centered show={showInfo}>
        <div>
          <div className={styles.closeButton} onClick={() => { tutupPertanyaan() }}>
            x
          </div>
        </div>
        <div style={{
          minHeight: 600,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          margin: 20
        }}>
          <div className='d-flex flex-column justify-content-center align-items-center'>
            <p className='fs-15 text-justify bold text-danger'>PERHATIAN !</p>
            <p className='fs-15 text-justify bold'>Kami sedang membacakan Kembali penjelasan Produk asuransi yang akan Anda beli.</p>
            <p className='fs-15 text-justify bold'>Mohon dapat mendengarkan dengan baik penjelasan yang diberikan.</p>
            <p className='fs-15 text-justify bold'>Jika Anda tidak dapat mendengar suara penjelasan, maka pastikan gadget Anda tidak berada dalam mode sunyi / senyap (silent mode).</p>
            <div style={{
              position: 'absolute',
              bottom: 0,
            }}>
              {(sudahPlay) ?
                <div onClick={() => {  updatePreambule(); handleStartRecording(); }}>
                  <div className={`${styles.containerButtonCam}`}>
                    <button className={`${styles.buttonambilfoto}`}>Konfirmasi</button>
                  </div>
                </div>
                :
                <div className={`${styles.containerButtonCam}`}>
                  <button disabled className={styles.buttonkonfirDisable}>Konfirmasi</button>
                </div>
              }
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}
export default RecordingVideo